export default "__VITE_ASSET__DpTtsjks__"